interface FeatureProps {
  featureFlag: boolean;
  children: JSX.Element;
  fallback: JSX.Element;
}
const FlaggedFeature = ({ featureFlag, children, fallback }: FeatureProps) => {
  if (featureFlag) {
    return children;
  } else if (fallback) {
    return fallback;
  }

  return null;
};

export default FlaggedFeature;
